import { ISelectItem } from '@lla-platform/core/core-ui'

export enum AnnouncementType {
  UserSent = 'UserSent',
  Scheduling = 'Scheduling',
  Attendance = 'Attendance',
  UnperformedServices = 'UnperformedServices'
}

export const AnnouncementTypeToLabel: Record<string, string> = {
  UserSent: 'Sent by user',
  Scheduling: 'Scheduling',
  Attendance: 'Attendance',
  UnperformedServices: 'Unperformed services'
}

export const AnnouncementTypeItems: ISelectItem[] = Object.values(AnnouncementType).map((value) => ({
  label: AnnouncementTypeToLabel[value],
  value
}))
